import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress Stripe-related errors that occur after Checkout redirect
// These errors happen because Stripe's checkout script tries to initialize
// but we're using hosted Checkout, so we don't need Stripe.js
const handleError = (event) => {
  // Suppress Stripe CheckoutInitError and module loading errors
  if (event.error && (
    event.error.message?.includes('apiKey is not set') ||
    event.error.message?.includes('CheckoutInitError') ||
    event.error.message?.includes("Cannot find module './en'")
  )) {
    event.preventDefault();
    console.log('Suppressed Stripe initialization error (expected when using hosted Checkout)');
    return false;
  }
};

const handleUnhandledRejection = (event) => {
  // Suppress unhandled promise rejections from Stripe
  if (event.reason && (
    event.reason.message?.includes('apiKey is not set') ||
    event.reason.message?.includes('CheckoutInitError') ||
    event.reason.message?.includes("Cannot find module './en'")
  )) {
    event.preventDefault();
    console.log('Suppressed Stripe promise rejection (expected when using hosted Checkout)');
    return false;
  }
};

// Add global error handlers
window.addEventListener('error', handleError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


